import { useTranslation } from 'react-i18next';
import type { CardSyncStatus } from '../../lib/dashboard/screenStatus';

export type { CardSyncStatus };

type SyncStatusPillProps = {
  status: CardSyncStatus;
};

const SYNC_LABEL_KEY = {
  'up-to-date': 'sync.upToDate',
  outdated: 'sync.outdated',
  unknown: 'sync.unknown',
} as const satisfies Record<CardSyncStatus, string>;

const SYNC_TONE: Record<CardSyncStatus, string> = {
  'up-to-date': 'text-ok',
  outdated: 'text-bad',
  unknown: 'text-muted',
};

const SYNC_DOT: Record<CardSyncStatus, string> = {
  'up-to-date': 'bg-ok',
  outdated: 'bg-bad',
  unknown: 'bg-muted',
};

export function SyncStatusPill({ status }: SyncStatusPillProps) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-line bg-canvas px-2.5 py-1 text-[11.5px] font-semibold ${SYNC_TONE[status]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${SYNC_DOT[status]}`} />
      {t(SYNC_LABEL_KEY[status])}
    </span>
  );
}
